const CardBrandsIcon = () => (
  <span className="flex items-center gap-1.5">
    {/* Mastercard */}
    <svg className="h-4 w-[26px]" viewBox="0 0 26 16" aria-hidden>
      <rect width="26" height="16" rx="2" fill="#fff" />
      <circle cx="10" cy="8" r="5" fill="#EB001B" />
      <circle cx="16" cy="8" r="5" fill="#F79E1B" fillOpacity="0.9" />
    </svg>
    {/* Maestro */}
    <svg className="h-4 w-[26px]" viewBox="0 0 26 16" aria-hidden>
      <rect width="26" height="16" rx="2" fill="#fff" />
      <circle cx="10" cy="8" r="5" fill="#0099DF" />
      <circle cx="16" cy="8" r="5" fill="#ED0006" fillOpacity="0.85" />
    </svg>
    {/* Visa */}
    <svg className="h-4 w-8" viewBox="0 0 32 16" aria-hidden>
      <rect width="32" height="16" rx="2" fill="#fff" />
      <text
        x="16"
        y="12"
        textAnchor="middle"
        fontSize="9"
        fontWeight="700"
        fontStyle="italic"
        fill="#1A1F71"
        fontFamily="Arial, sans-serif"
      >
        VISA
      </text>
    </svg>
    {/* Amex */}
    <svg className="h-4 w-[26px]" viewBox="0 0 26 16" aria-hidden>
      <rect width="26" height="16" rx="2" fill="#1F72CD" />
      <text
        x="13"
        y="11"
        textAnchor="middle"
        fontSize="5.5"
        fontWeight="700"
        fill="#fff"
        fontFamily="Arial, sans-serif"
      >
        AMEX
      </text>
    </svg>
    {/* JCB */}
    <svg className="h-4 w-[22px]" viewBox="0 0 22 16" aria-hidden>
      <rect width="7" height="16" rx="1" fill="#0E4C96" />
      <rect x="7.5" width="7" height="16" rx="1" fill="#D81E05" />
      <rect x="15" width="7" height="16" rx="1" fill="#21A14A" />
    </svg>
  </span>
);

export default CardBrandsIcon;
